export default "__VITE_ASSET__jhe6XGOe__"